'use strict';
var base = require('./base');

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('#bulkorderModal').length !== 0) {
        $('#bulkorderModal').remove();
    }
    var htmlString = '<!-- Modal -->' +
        '<div class="modal fade" id="bulkorderModal" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog modal-lg bulk-order-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <a class="full-pdp-link" href=""></a>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from bulkorder template
 * @return {QuickViewHtml} - Bulk order content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.modal-bulkorder');
    var footer = $html.find('.modal-bulkorder-footer');

    return {
        body: body,
        footer: footer
    };
}

/**
 * replaces the content in the modal window with the product's bulk order options
 * @param {string} selectedValueUrl - url to be used to retrieve bulkorder content
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-content').spinner().start();
    $.when( $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#bulkorderModal .modal-body').empty();
            $('#bulkorderModal .modal-body').html(parsedHtml.body);
            $('#bulkorderModal .modal-footer').html(parsedHtml.footer);
            $('#bulkorderModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    })).then(function() {
        // init modal functions
        bulkAddToCart();
        updateSubtotal();
    });
}

// Bulk Add to Cart
function bulkAddToCart() {
    $('.bulk-add-to-cart').on('click', function () {
        $.spinner().start();
        $('.bulk-add-to-cart').addClass('btn-spinner').prop('disabled', true);
        var pidsObj;
        var setPids = [];
        var isBulkQtyValid = true;

        $('.js-bulk-product').each(function () {
            var productQty = $(this).val();
            
            if (productQty.length > 0 && productQty > 0) {
                isBulkQtyValid = validateBulkQuantity($(this));

                if (!isBulkQtyValid) {
                    $('.bulk-add-to-cart').removeClass('btn-spinner');
                    $('.bulk-add-to-cart').removeAttr('disabled');
                    $.spinner().stop();
                    return false;
                }
                
                setPids.push({
                    pid: $(this).data('pid'),
                    qty: productQty,
                    options: JSON.stringify($(this).data('options'))
                });
            }
        });

        if (isBulkQtyValid && setPids.length > 0) {
            pidsObj = JSON.stringify(setPids);

            var form = {
                pidsObj: pidsObj
            };
    
            $.ajax({
                url: $('.bulk-add-to-cart').data('url'),
                method: 'POST',
                data: form,
                success: function (data) {
                    window.location.href = data.cartShowURL;
                },
                error: function () {
                    $('.bulk-add-to-cart').removeClass('btn-spinner');
                    $('.bulk-add-to-cart').removeAttr('disabled');
                    $.spinner().stop();
                }
            });
        } else {
            $('.bulk-add-to-cart').removeClass('btn-spinner');
            $('.bulk-add-to-cart').removeAttr('disabled');
            $.spinner().stop();
        }
    });
}

// Updates Group Subtotal
function updateSubtotal() {
    $('.js-bulk-product').on('keyup', function () {
        var totalPrice = 0.00;

        $('.js-bulk-product').each(function () {
            var $this = $(this);
            var inputQty = $this.val();
            if (inputQty.length > 0 && inputQty > 0) {
                var price = parseFloat($this.data('price'));
                totalPrice += price * inputQty;
            }
        });
        
        totalPrice = totalPrice.toFixed(2);
        $('.price-group').text(totalPrice);
    });
}

function validateBulkQuantity(quantityContainer) {
    var isValid = true;
    var qtyValue = quantityContainer.val();
    var max = quantityContainer.attr('data-max');
    var pliMax = quantityContainer.attr('data-plimax');
    max = parseInt(max);
    pliMax = parseInt(pliMax);

    if (qtyValue > max) {
        isValid = false;
        var errorMessage = '';

        if (max >= pliMax) {
            pliMax = pliMax.toFixed();
            errorMessage = "Sorry, only a quantity of " + pliMax + " can be added at a time. Please reduce the quantity and try again.";
        } else {
            var message = "Items are in stock";
            if (max == 1) {
                message = "Item is in stock";
            }
            max = max.toFixed();
            errorMessage = "Only " + max + " " + message;
        }

        alert(errorMessage);
        quantityContainer.focus();
    }
    return isValid;
}

module.exports = {
    showBulkOrder: function () {
        $('body').on('click', '.bulk-order', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).attr('href');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    }
};